import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { ModelKPICalculator } from "../types";

export const useModelKPICalculator = (model_id: number) => {
  return useQuery({
    queryKey: ["model", "charts", "kpis_calculator", model_id],
    enabled: model_id > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/${model_id}/charts/kpis_calculator`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ModelKPICalculator;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
